import React from "react";

import { Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";

import { faPencil } from "@fortawesome/pro-solid-svg-icons";

import { EContractAction } from "actions";

import IconTextButton from "components/Button/IconTextButton";
import { MainContentWrapper } from "components/Layout";
import WaitForSync from "components/LoadingSpinner/WaitForSync";
import { Paper } from "components/Paper";
import { BoldText, TitleText } from "components/Text";

import { ApiModel } from "constants/loading";

import {
  getActiveRole,
  getCurrentSale,
  selectEContracts,
  selectSaleLotIdsWithoutActiveEContract,
} from "selectors";

import { useMountEffect } from "hooks";

import { EContractSummaryCard } from "./eContractCard";

export const EContractView = (): React.JSX.Element => {
  const livestockSale = useSelector(getCurrentSale);
  const { slug: activeRoleSlug } = useSelector(getActiveRole);
  const eContractsByCode = useSelector(selectEContracts);
  const saleLotIdsWithoutActiveEContract = useSelector(
    selectSaleLotIdsWithoutActiveEContract,
  );

  const dispatch = useDispatch();

  useMountEffect(() => {
    dispatch(EContractAction.request());
  });

  const onGenerate = () => {
    dispatch(EContractAction.generate());
  };

  // For private sales, the deployment_sales quantity will always be 1.
  const deploymentSaleId = livestockSale.deployment_sales[0].deployment_sale_id;

  const createHandler = ({ buyerBusinessId, vendorBusinessId }) => {
    const payload: Partial<EContract> = {
      buyerBusinessId,
      deploymentSaleId,
      vendorBusinessId,
    };
    dispatch(EContractAction.create(payload));
  };

  return (
    <WaitForSync
      requiredData={[
        ApiModel.BUSINESSES,
        ApiModel.CONSIGNMENTS,
        ApiModel.DEPLOYMENTS,
        ApiModel.ECONTRACTS,
        ApiModel.LIVESTOCK_AGENTS,
      ]}
      subjectName="eContracts"
    >
      <MainContentWrapper>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Paper elevation={1} backgroundColor="grayF3">
              <TitleText block>eContracts</TitleText>
              <p>
                eContracts use the data you&apos;ve already added.
                <br />
                To modify content of an eContract, modify Sale, Lot or
                Consignment data then void any existing contracts, and click
                Draft New.
              </p>
              <Grid container justifyContent="flex-end">
                <IconTextButton
                  disabled={saleLotIdsWithoutActiveEContract.length === 0}
                  icon={faPencil}
                  onClick={onGenerate}
                >
                  <BoldText>
                    Generate Draft Contracts for{" "}
                    {saleLotIdsWithoutActiveEContract.length} Lots
                  </BoldText>
                </IconTextButton>
              </Grid>
            </Paper>
          </Grid>
          {Object.values(eContractsByCode).map(eContracts => {
            const latestEContract = eContracts[0];
            return (
              <Grid item xs={12} key={latestEContract.id}>
                <EContractSummaryCard
                  createHandler={createHandler}
                  eContracts={eContracts}
                  userRoleSlug={activeRoleSlug}
                />
              </Grid>
            );
          })}
        </Grid>
      </MainContentWrapper>
    </WaitForSync>
  );
};
